import http from "../common/http";
import authHeader from "./header";
import { SERVICE_API_URL } from "../common/config";

const relicFindAll = (params) => {
  return http.get(SERVICE_API_URL + `/relics`, {
    params: params,
    headers: authHeader(),
  });
};

const relicFindOne = (id, params) => {
  return http.get(SERVICE_API_URL + `/relics/${id}`, params, {
    headers: authHeader(),
  });
};
export default {
  relicFindAll,
  relicFindOne,
};
